module.exports = __webpack_public_path__ + "static/media/section_4_A.ef20ebb5.png";